import React from "react";

// account subsidiary is determined by SFDC
// it is essentially used to determine which Stripe instance the account is connected to and how to apply the tax
export const ACCOUNT_SUBSIDIARY_LIBRARY = {
  "Criteria NA": "NA",
  "Criteria AUS": "AU",
};

export const USD_CURRENCY_FORMAT = {
  style: "currency",
  currency: "USD",
};

// a helper library indicating which country requires which fields
export const BILLING_INFO_INPUT_REQUIREMENTS_LIBRARY = {
  zipCode: ["US", "AU"],
  state: ["US", "AU"],
};

export const SALES_TAX_VERBIAGE = {
  US: {
    label: "Applicable taxes",
    definition:
      'Due to the 2018 US Supreme Court South Dakota v Wayfair decision, SALES AND USE TAX must be charged for remote access of pre-written software (Software as a Service, SAAS) in states where our product is currently taxable. If your entity is tax exempt or self-assess and file, please email your exemption form to <a href="mailto:accounting@criteriacorp.com">accounting@criteriacorp.com</a> and we will recalculate your invoice.',
  },
  AU: {
    label: "GST",
    definition:
      'Criteria Australia Pty Ltd, ABN 58 089 022 202 is registered for GST and we must charge GST for the remote access of pre-written software (Software as a Service, SAAS) sold and consumed in Australia. GST is not applicable to services consumed outside of Australia. Please contact <a href="mailto:apac.accounts@criteriacorp.com">apac.accounts@criteriacorp.com</a> if you require further information.',
  },
};

// State Name and Abbreviation array to use for Selects
export const statesArray = [
  {
    name: "Outside U.S.",
    abbreviation: "XX",
  },
  {
    name: "Alabama",
    abbreviation: "AL",
  },
  {
    name: "Alaska",
    abbreviation: "AK",
  },
  {
    name: "American Samoa",
    abbreviation: "AS",
  },
  {
    name: "Arizona",
    abbreviation: "AZ",
  },
  {
    name: "Arkansas",
    abbreviation: "AR",
  },
  {
    name: "California",
    abbreviation: "CA",
  },
  {
    name: "Colorado",
    abbreviation: "CO",
  },
  {
    name: "Connecticut",
    abbreviation: "CT",
  },
  {
    name: "Delaware",
    abbreviation: "DE",
  },
  {
    name: "District Of Columbia",
    abbreviation: "DC",
  },
  {
    name: "Florida",
    abbreviation: "FL",
  },
  {
    name: "Georgia",
    abbreviation: "GA",
  },
  {
    name: "Guam",
    abbreviation: "GU",
  },
  {
    name: "Hawaii",
    abbreviation: "HI",
  },
  {
    name: "Idaho",
    abbreviation: "ID",
  },
  {
    name: "Illinois",
    abbreviation: "IL",
  },
  {
    name: "Indiana",
    abbreviation: "IN",
  },
  {
    name: "Iowa",
    abbreviation: "IA",
  },
  {
    name: "Kansas",
    abbreviation: "KS",
  },
  {
    name: "Kentucky",
    abbreviation: "KY",
  },
  {
    name: "Louisiana",
    abbreviation: "LA",
  },
  {
    name: "Maine",
    abbreviation: "ME",
  },
  {
    name: "Maryland",
    abbreviation: "MD",
  },
  {
    name: "Massachusetts",
    abbreviation: "MA",
  },
  {
    name: "Michigan",
    abbreviation: "MI",
  },
  {
    name: "Minnesota",
    abbreviation: "MN",
  },
  {
    name: "Mississippi",
    abbreviation: "MS",
  },
  {
    name: "Missouri",
    abbreviation: "MO",
  },
  {
    name: "Montana",
    abbreviation: "MT",
  },
  {
    name: "Nebraska",
    abbreviation: "NE",
  },
  {
    name: "Nevada",
    abbreviation: "NV",
  },
  {
    name: "New Hampshire",
    abbreviation: "NH",
  },
  {
    name: "New Jersey",
    abbreviation: "NJ",
  },
  {
    name: "New Mexico",
    abbreviation: "NM",
  },
  {
    name: "New York",
    abbreviation: "NY",
  },
  {
    name: "North Carolina",
    abbreviation: "NC",
  },
  {
    name: "North Dakota",
    abbreviation: "ND",
  },
  {
    name: "Northern Mariana Islands",
    abbreviation: "MP",
  },
  {
    name: "Ohio",
    abbreviation: "OH",
  },
  {
    name: "Oklahoma",
    abbreviation: "OK",
  },
  {
    name: "Oregon",
    abbreviation: "OR",
  },
  {
    name: "Palau",
    abbreviation: "PW",
  },
  {
    name: "Pennsylvania",
    abbreviation: "PA",
  },
  {
    name: "Puerto Rico",
    abbreviation: "PR",
  },
  {
    name: "Rhode Island",
    abbreviation: "RI",
  },
  {
    name: "South Carolina",
    abbreviation: "SC",
  },
  {
    name: "South Dakota",
    abbreviation: "SD",
  },
  {
    name: "Tennessee",
    abbreviation: "TN",
  },
  {
    name: "Texas",
    abbreviation: "TX",
  },
  {
    name: "U.S. Virgin Islands",
    abbreviation: "VI",
  },
  {
    name: "Utah",
    abbreviation: "UT",
  },
  {
    name: "Vermont",
    abbreviation: "VT",
  },
  {
    name: "Virginia",
    abbreviation: "VA",
  },
  {
    name: "Washington",
    abbreviation: "WA",
  },
  {
    name: "West Virginia",
    abbreviation: "WV",
  },
  {
    name: "Wisconsin",
    abbreviation: "WI",
  },
  {
    name: "Wyoming",
    abbreviation: "WY",
  },
];

// Australian State Name and Abbreviation array to use for Selects
export const AUStatesArray = [
  {
    name: "Outside U.S.",
    abbreviation: "XX",
  }, // State is not required for Australia so we put this one as the default
  {
    name: "Australian Capital Territory",
    abbreviation: "ACT",
  },
  {
    name: "New South Wales",
    abbreviation: "NSW",
  },
  {
    name: "Northern Territory",
    abbreviation: "NT",
  },
  {
    name: "Queensland",
    abbreviation: "QLD",
  },
  {
    name: "Tasmania",
    abbreviation: "TAS",
  },
  {
    name: "Victoria",
    abbreviation: "VIC",
  },
  {
    name: "Western Australia",
    abbreviation: "WA",
  },
  {
    name: "South Australia",
    abbreviation: "SA",
  },
];

// Canadian State Name and Abbreviation array to use for Selects
export const CAStatesArray = [
  {
    name: "Outside U.S.",
    abbreviation: "XX",
  }, // State is not required for Canada so we put this one as the default
  {
    name: "Alberta",
    abbreviation: "AB",
  },
  {
    name: "British Columbia",
    abbreviation: "BC",
  },
  {
    name: "Manitoba",
    abbreviation: "MB",
  },
  {
    name: "New Brunswick",
    abbreviation: "NB",
  },
  {
    name: "Newfoundland and Labrador",
    abbreviation: "NL",
  },
  {
    name: "Nova Scotia",
    abbreviation: "NS",
  },
  {
    name: "Ontario",
    abbreviation: "ON",
  },
  {
    name: "Prince Edward Island",
    abbreviation: "PE",
  },
  {
    name: "Quebec",
    abbreviation: "QC",
  },
  {
    name: "Saskatchewan",
    abbreviation: "SK",
  },
];

// Set up State options for the State select in the Billing Info form
export const getStateOptions = (selectedCountry) => {
  let statesArrayToUse = statesArray;
  if (selectedCountry === "AU") {
    statesArrayToUse = AUStatesArray;
  }
  if (selectedCountry === "CA") {
    statesArrayToUse = CAStatesArray;
  }

  return statesArrayToUse.map((state) => (
    <option key={state.abbreviation} value={state.abbreviation}>
      {state.name}
    </option>
  ));
};

export const countryOptions = [
  <option key="selectOneCountry" value="">
    Select one
  </option>,
  <option key="US1" value="US">
    United States of America
  </option>,
  <option key="CA1" value="CA">
    Canada
  </option>,
  <option key="AU" value="AU">
    Australia
  </option>,
  <option key="selectCountryBreak" value="">
    ----------
  </option>,
  <option key="AF" value="AF">
    Afghanistan
  </option>,
  <option key="AX" value="AX">
    Aland Islands
  </option>,
  <option key="AL" value="AL">
    Albania
  </option>,
  <option key="DZ" value="DZ">
    Algeria
  </option>,
  <option key="AD" value="AD">
    Andorra
  </option>,
  <option key="AO" value="AO">
    Angola
  </option>,
  <option key="AI" value="AI">
    Anguilla
  </option>,
  <option key="AQ" value="AQ">
    Antarctica
  </option>,
  <option key="AG" value="AG">
    Antigua and Barbuda
  </option>,
  <option key="AR" value="AR">
    Argentina
  </option>,
  <option key="AM" value="AM">
    Armenia
  </option>,
  <option key="AW" value="AW">
    Aruba
  </option>,
  <option key="AT" value="AT">
    Austria
  </option>,
  <option key="AZ" value="AZ">
    Azerbaijan
  </option>,
  <option key="BS" value="BS">
    Bahamas
  </option>,
  <option key="BH" value="BH">
    Bahrain
  </option>,
  <option key="BD" value="BD">
    Bangladesh
  </option>,
  <option key="BB" value="BB">
    Barbados
  </option>,
  <option key="BY" value="BY">
    Belarus
  </option>,
  <option key="BE" value="BE">
    Belgium
  </option>,
  <option key="BZ" value="BZ">
    Belize
  </option>,
  <option key="BJ" value="BJ">
    Benin
  </option>,
  <option key="BM" value="BM">
    Bermuda
  </option>,
  <option key="BT" value="BT">
    Bhutan
  </option>,
  <option key="BO" value="BO">
    Bolivia
  </option>,
  <option key="BA" value="BA">
    Bosnia and Herzegovina
  </option>,
  <option key="BW" value="BW">
    Botswana
  </option>,
  <option key="BV" value="BV">
    Bouvet Island
  </option>,
  <option key="BR" value="BR">
    Brazil
  </option>,
  <option key="IO" value="IO">
    British Indian Ocean Territory
  </option>,
  <option key="BN" value="BN">
    Brunei Darussalam
  </option>,
  <option key="BG" value="BG">
    Bulgaria
  </option>,
  <option key="BF" value="BF">
    Burkina Faso
  </option>,
  <option key="BI" value="BI">
    Burundi
  </option>,
  <option key="KH" value="KH">
    Cambodia
  </option>,
  <option key="CM" value="CM">
    Cameroon
  </option>,
  <option key="CA" value="CA">
    Canada
  </option>,
  <option key="CV" value="CV">
    Cape Verde
  </option>,
  <option key="KY" value="KY">
    Cayman Islands
  </option>,
  <option key="CF" value="CF">
    Central African Republic
  </option>,
  <option key="TD" value="TD">
    Chad
  </option>,
  <option key="CL" value="CL">
    Chile
  </option>,
  <option key="CN" value="CN">
    China
  </option>,
  <option key="CX" value="CX">
    Christmas Island
  </option>,
  <option key="CC" value="CC">
    Cocos (Keeling) Islands
  </option>,
  <option key="CO" value="CO">
    Colombia
  </option>,
  <option key="KM" value="KM">
    Comoros
  </option>,
  <option key="CG" value="CG">
    Congo
  </option>,
  <option key="CD" value="CD">
    Congo, The Democratic Republic of the
  </option>,
  <option key="CK" value="CK">
    Cook Islands
  </option>,
  <option key="CR" value="CR">
    Costa Rica
  </option>,
  <option key="CI" value="CI">
    Cote D'Ivoire
  </option>,
  <option key="HR" value="HR">
    Croatia
  </option>,
  <option key="CY" value="CY">
    Cyprus
  </option>,
  <option key="CZ" value="CZ">
    Czech Republic
  </option>,
  <option key="DK" value="DK">
    Denmark
  </option>,
  <option key="DJ" value="DJ">
    Djibouti
  </option>,
  <option key="DM" value="DM">
    Dominica
  </option>,
  <option key="DO" value="DO">
    Dominican Republic
  </option>,
  <option key="EC" value="EC">
    Ecuador
  </option>,
  <option key="EG" value="EG">
    Egypt
  </option>,
  <option key="SV" value="SV">
    El Salvador
  </option>,
  <option key="GQ" value="GQ">
    Equatorial Guinea
  </option>,
  <option key="ER" value="ER">
    Eritrea
  </option>,
  <option key="EE" value="EE">
    Estonia
  </option>,
  <option key="ET" value="ET">
    Ethiopia
  </option>,
  <option key="FK" value="FK">
    Falkland Islands (Malvinas)
  </option>,
  <option key="FO" value="FO">
    Faroe Islands
  </option>,
  <option key="FJ" value="FJ">
    Fiji
  </option>,
  <option key="FI" value="FI">
    Finland
  </option>,
  <option key="FR" value="FR">
    France
  </option>,
  <option key="GF" value="GF">
    French Guiana
  </option>,
  <option key="PF" value="PF">
    French Polynesia
  </option>,
  <option key="TF" value="TF">
    French Southern Territories
  </option>,
  <option key="GA" value="GA">
    Gabon
  </option>,
  <option key="GM" value="GM">
    Gambia
  </option>,
  <option key="GE" value="GE">
    Georgia
  </option>,
  <option key="DE" value="DE">
    Germany
  </option>,
  <option key="GH" value="GH">
    Ghana
  </option>,
  <option key="GI" value="GI">
    Gibraltar
  </option>,
  <option key="GR" value="GR">
    Greece
  </option>,
  <option key="GL" value="GL">
    Greenland
  </option>,
  <option key="GD" value="GD">
    Grenada
  </option>,
  <option key="GP" value="GP">
    Guadeloupe
  </option>,
  <option key="GT" value="GT">
    Guatemala
  </option>,
  <option key="GG" value="GG">
    Guernsey
  </option>,
  <option key="GN" value="GN">
    Guinea
  </option>,
  <option key="GW" value="GW">
    Guinea-Bissau
  </option>,
  <option key="GY" value="GY">
    Guyana
  </option>,
  <option key="HT" value="HT">
    Haiti
  </option>,
  <option key="HM" value="HM">
    Heard Island and McDonald Islands
  </option>,
  <option key="VA" value="VA">
    Holy See (Vatican City State)
  </option>,
  <option key="HN" value="HN">
    Honduras
  </option>,
  <option key="HK" value="HK">
    Hong Kong
  </option>,
  <option key="HU" value="HU">
    Hungary
  </option>,
  <option key="IS" value="IS">
    Iceland
  </option>,
  <option key="IN" value="IN">
    India
  </option>,
  <option key="ID" value="ID">
    Indonesia
  </option>,
  <option key="IQ" value="IQ">
    Iraq
  </option>,
  <option key="IE" value="IE">
    Ireland
  </option>,
  <option key="IM" value="IM">
    Isle of Man
  </option>,
  <option key="IL" value="IL">
    Israel
  </option>,
  <option key="IT" value="IT">
    Italy
  </option>,
  <option key="JM" value="JM">
    Jamaica
  </option>,
  <option key="JP" value="JP">
    Japan
  </option>,
  <option key="JE" value="JE">
    Jersey
  </option>,
  <option key="JO" value="JO">
    Jordan
  </option>,
  <option key="KZ" value="KZ">
    Kazakstan
  </option>,
  <option key="KE" value="KE">
    Kenya
  </option>,
  <option key="KI" value="KI">
    Kiribati
  </option>,
  <option key="KR" value="KR">
    Korea, Republic of
  </option>,
  <option key="KW" value="KW">
    Kuwait
  </option>,
  <option key="KG" value="KG">
    Kyrgyzstan
  </option>,
  <option key="LA" value="LA">
    Lao People's Democratic Republic
  </option>,
  <option key="LV" value="LV">
    Latvia
  </option>,
  <option key="LB" value="LB">
    Lebanon
  </option>,
  <option key="LS" value="LS">
    Lesotho
  </option>,
  <option key="LR" value="LR">
    Liberia
  </option>,
  <option key="LY" value="LY">
    Libyan Arab Jamahiriya
  </option>,
  <option key="LI" value="LI">
    Liechtenstein
  </option>,
  <option key="LT" value="LT">
    Lithuania
  </option>,
  <option key="LU" value="LU">
    Luxembourg
  </option>,
  <option key="MO" value="MO">
    Macao
  </option>,
  <option key="MK" value="MK">
    Macedonia, The Former Yugoslav Republic of
  </option>,
  <option key="MG" value="MG">
    Madagascar
  </option>,
  <option key="MW" value="MW">
    Malawi
  </option>,
  <option key="MY" value="MY">
    Malaysia
  </option>,
  <option key="MV" value="MV">
    Maldives
  </option>,
  <option key="ML" value="ML">
    Mali
  </option>,
  <option key="MT" value="MT">
    Malta
  </option>,
  <option key="MH" value="MH">
    Marshall Islands
  </option>,
  <option key="MQ" value="MQ">
    Martinique
  </option>,
  <option key="MR" value="MR">
    Mauritania
  </option>,
  <option key="MU" value="MU">
    Mauritius
  </option>,
  <option key="YT" value="YT">
    Mayotte
  </option>,
  <option key="MX" value="MX">
    Mexico
  </option>,
  <option key="FM" value="FM">
    Micronesia, Federated States of
  </option>,
  <option key="MD" value="MD">
    Moldova
  </option>,
  <option key="MC" value="MC">
    Monaco
  </option>,
  <option key="MN" value="MN">
    Mongolia
  </option>,
  <option key="ME" value="ME">
    Montenegro
  </option>,
  <option key="MS" value="MS">
    Montserrat
  </option>,
  <option key="MA" value="MA">
    Morocco
  </option>,
  <option key="MZ" value="MZ">
    Mozambique
  </option>,
  <option key="MM" value="MM">
    Myanmar
  </option>,
  <option key="NA" value="NA">
    Namibia
  </option>,
  <option key="NR" value="NR">
    Nauru
  </option>,
  <option key="NP" value="NP">
    Nepal
  </option>,
  <option key="NL" value="NL">
    Netherlands
  </option>,
  <option key="AN" value="AN">
    Netherlands Antilles
  </option>,
  <option key="NC" value="NC">
    New Caledonia
  </option>,
  <option key="NZ" value="NZ">
    New Zealand
  </option>,
  <option key="NI" value="NI">
    Nicaragua
  </option>,
  <option key="NE" value="NE">
    Niger
  </option>,
  <option key="NG" value="NG">
    Nigeria
  </option>,
  <option key="NU" value="NU">
    Niue
  </option>,
  <option key="NF" value="NF">
    Norfolk Island
  </option>,
  <option key="NO" value="NO">
    Norway
  </option>,
  <option key="OM" value="OM">
    Oman
  </option>,
  <option key="PK" value="PK">
    Pakistan
  </option>,
  <option key="PW" value="PW">
    Palau
  </option>,
  <option key="PS" value="PS">
    Palestinian Territory, Occupied
  </option>,
  <option key="PA" value="PA">
    Panama
  </option>,
  <option key="PG" value="PG">
    Papua New Guinea
  </option>,
  <option key="PY" value="PY">
    Paraguay
  </option>,
  <option key="PE" value="PE">
    Peru
  </option>,
  <option key="PH" value="PH">
    Philippines
  </option>,
  <option key="PN" value="PN">
    Pitcairn
  </option>,
  <option key="PL" value="PL">
    Poland
  </option>,
  <option key="PT" value="PT">
    Portugal
  </option>,
  <option key="QA" value="QA">
    Qatar
  </option>,
  <option key="RE" value="RE">
    Reunion
  </option>,
  <option key="RO" value="RO">
    Romania
  </option>,
  <option key="RW" value="RW">
    Rwanda
  </option>,
  <option key="BL" value="BL">
    Saint Barthelemy
  </option>,
  <option key="SH" value="SH">
    Saint Helena, Ascension and Tristan da Cunha
  </option>,
  <option key="KN" value="KN">
    Saint Kitts and Nevis
  </option>,
  <option key="LC" value="LC">
    Saint Lucia
  </option>,
  <option key="MF" value="MF">
    Saint Martin
  </option>,
  <option key="PM" value="PM">
    Saint Pierre and Miquelon
  </option>,
  <option key="VC" value="VC">
    Saint Vincent and the Grenadines
  </option>,
  <option key="WS" value="WS">
    Samoa
  </option>,
  <option key="SM" value="SM">
    San Marino
  </option>,
  <option key="ST" value="ST">
    Sao Tome and Principe
  </option>,
  <option key="SA" value="SA">
    Saudi Arabia
  </option>,
  <option key="SN" value="SN">
    Senegal
  </option>,
  <option key="RS" value="RS">
    Serbia
  </option>,
  <option key="SC" value="SC">
    Seychelles
  </option>,
  <option key="SL" value="SL">
    Sierra Leone
  </option>,
  <option key="SG" value="SG">
    Singapore
  </option>,
  <option key="SK" value="SK">
    Slovakia
  </option>,
  <option key="SI" value="SI">
    Slovenia
  </option>,
  <option key="SB" value="SB">
    Solomon Islands
  </option>,
  <option key="SO" value="SO">
    Somalia
  </option>,
  <option key="ZA" value="ZA">
    South Africa
  </option>,
  <option key="GS" value="GS">
    South Georgia and the South Sandwich Islands
  </option>,
  <option key="ES" value="ES">
    Spain
  </option>,
  <option key="LK" value="LK">
    Sri Lanka
  </option>,
  <option key="SD" value="SD">
    Sudan
  </option>,
  <option key="SR" value="SR">
    Suriname
  </option>,
  <option key="SJ" value="SJ">
    Svalbard and Jan Mayen
  </option>,
  <option key="SZ" value="SZ">
    Swaziland
  </option>,
  <option key="SE" value="SE">
    Sweden
  </option>,
  <option key="CH" value="CH">
    Switzerland
  </option>,
  <option key="TW" value="TW">
    Taiwan
  </option>,
  <option key="TJ" value="TJ">
    Tajikistan
  </option>,
  <option key="TZ" value="TZ">
    Tanzania, United Republic of
  </option>,
  <option key="TH" value="TH">
    Thailand
  </option>,
  <option key="TL" value="TL">
    Timor-Leste
  </option>,
  <option key="TG" value="TG">
    Togo
  </option>,
  <option key="TK" value="TK">
    Tokelau
  </option>,
  <option key="TO" value="TO">
    Tonga
  </option>,
  <option key="TT" value="TT">
    Trinidad and Tobago
  </option>,
  <option key="TN" value="TN">
    Tunisia
  </option>,
  <option key="TR" value="TR">
    Turkey
  </option>,
  <option key="TM" value="TM">
    Turkmenistan
  </option>,
  <option key="TC" value="TC">
    Turks and Caicos Islands
  </option>,
  <option key="TV" value="TV">
    Tuvalu
  </option>,
  <option key="UG" value="UG">
    Uganda
  </option>,
  <option key="AE" value="AE">
    United Arab Emirates
  </option>,
  <option key="GB" value="GB">
    United Kingdom
  </option>,
  <option key="US2" value="US">
    United States of America
  </option>,
  <option key="UY" value="UY">
    Uruguay
  </option>,
  <option key="UZ" value="UZ">
    Uzbekistan
  </option>,
  <option key="VU" value="VU">
    Vanuatu
  </option>,
  <option key="VE" value="VE">
    Venezuela
  </option>,
  <option key="VN" value="VN">
    Vietnam
  </option>,
  <option key="VG" value="VG">
    Virgin Islands, British
  </option>,
  <option key="WF" value="WF">
    Wallis and Futuna
  </option>,
  <option key="EH" value="EH">
    Western Sahara
  </option>,
  <option key="YE" value="YE">
    Yemen
  </option>,
  <option key="ZM" value="ZM">
    Zambia
  </option>,
  <option key="ZW" value="ZW">
    Zimbabwe
  </option>,
];

export const monthOptions = [
  <option key="selectOneMonth" value="">
    Select one
  </option>,
  <option key="01" value="01">
    01
  </option>,
  <option key="02" value="02">
    02
  </option>,
  <option key="03" value="03">
    03
  </option>,
  <option key="04" value="04">
    04
  </option>,
  <option key="05" value="05">
    05
  </option>,
  <option key="06" value="06">
    06
  </option>,
  <option key="07" value="07">
    07
  </option>,
  <option key="08" value="08">
    08
  </option>,
  <option key="09" value="09">
    09
  </option>,
  <option key="10" value="10">
    10
  </option>,
  <option key="11" value="11">
    11
  </option>,
  <option key="12" value="12">
    12
  </option>,
];

export const getFormattedPrice = (price) =>
  new Intl.NumberFormat("en-US", USD_CURRENCY_FORMAT).format(price);
